import { getAnimationConfiguration } from '../../hooks/helpers';
import animationData from '../../lotties/coding.json';

export const defaultOptions = getAnimationConfiguration(animationData);
export const title = ['Creating.', 'Developing.', 'Delivering.'];
